import { render, staticRenderFns } from "./AdminNotificationCenter.vue?vue&type=template&id=22d8469b&scoped=true&"
import script from "./AdminNotificationCenter.vue?vue&type=script&lang=js&"
export * from "./AdminNotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotificationCenter.vue?vue&type=style&index=0&id=22d8469b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8469b",
  null
  
)

export default component.exports